exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-6d003b0e] {\n    -webkit-transition: opacity .2s;\n    transition: opacity .2s;\n}\n.fade-enter[data-v-6d003b0e]/* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\n", ""]);

// exports
